import { render } from "./Suppliers.vue?vue&type=template&id=4f15a07e&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=js"
export * from "./Suppliers.vue?vue&type=script&lang=js"

import "./Suppliers.vue?vue&type=style&index=0&id=4f15a07e&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f15a07e"]])

export default __exports__